import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";


export default class Category extends Framework.Components.Object {
	constructor(props) {

		super(props, Types.Categories._name);
	}


	form = () => {
		let {properties} = this.model;
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-12"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/></div>

		)
	}
}
